// Default date formats
export const headerFormat = 'MMMM yyyy';
export const daysFormat = 'EEE';
export const cellsFormat = 'd';
export const cellsFormatKey = 'd-LL';
